import React from 'react'
import EnderecoListPageContainer from './EnderecoListPageContainer'

export class EnderecoListPage extends React.Component {
  render() {
    return <EnderecoListPageContainer {...this.props} />
  }
}
